import { render } from "./user-dashboard-modal.vue?vue&type=template&id=9d4bbb98"
import script from "./user-dashboard-modal.vue?vue&type=script&lang=js"
export * from "./user-dashboard-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__